module.exports = __webpack_public_path__ + "static/media/logo-noborder.c65cb0d8.png";